import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { UserService } from '../services/user/user-svc.ng';

export function AuthIntercept(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
    // #region Injects

    const userSvc = inject(UserService);

    // #endregion

    const authToken = userSvc.user()?.AuthToken ?? '';

    let headers = req.headers;
    if (authToken) {
        headers = headers.append('AuthToken', authToken);
    }

    const clonedReq = req.clone({ headers });

    return next(clonedReq).pipe(
        catchError((err: HttpErrorResponse) => {
            // let error = autherrorSvc.handleError(err, req, next);
            return throwError(() => err);
        })
    );
}
